/* Careatic "Shop by breed" focus carousel — seamless infinite loop.
   The active card centers (CSS scales/dims neighbours); the breed cut-out pops
   above the card. Auto-advances smoothly right-to-left without ever rewinding:
   the real cards are flanked by clones, and the track silently snaps back by one
   set once a move lands in the clones. Prev/Next + dots + keyboard + swipe. */
(function () {
  'use strict';

  var DUR = 600; // must match .ca-bc__track transition duration (ms)

  function init(root) {
    var viewport = root.querySelector('[data-ca-bc-viewport]');
    var track = root.querySelector('[data-ca-bc-track]');
    var reals = Array.prototype.slice.call(root.querySelectorAll('[data-ca-bc-card]'));
    var prev = root.querySelector('[data-ca-bc-prev]');
    var next = root.querySelector('[data-ca-bc-next]');
    var dotsWrap = root.parentNode.querySelector('[data-ca-bc-dots]');
    if (!viewport || !track || !reals.length) return;

    var N = reals.length;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Build [clones][reals][clones] so the focus can always travel left. */
    var lead = reals.map(function (c) { return c.cloneNode(true); });
    var tail = reals.map(function (c) { return c.cloneNode(true); });
    lead.forEach(function (c) { c.setAttribute('data-clone', '1'); track.insertBefore(c, reals[0]); });
    tail.forEach(function (c) { c.setAttribute('data-clone', '1'); track.appendChild(c); });
    var cards = Array.prototype.slice.call(track.querySelectorAll('[data-ca-bc-card]')); // 3N

    var index = N + Math.floor((N - 1) / 2); // start centred on a middle real card
    var timer = null, busy = false;

    /* dots reflect the real breed under focus */
    var dots = [];
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      reals.forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'ca-bc__dot';
        b.setAttribute('aria-label', 'Go to breed ' + (i + 1));
        b.addEventListener('click', function () { go(N + i, true); });
        dotsWrap.appendChild(b); dots.push(b);
      });
    }

    function metrics() {
      var w = cards[0].offsetWidth;                 // layout width (scale doesn't affect it)
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap) || 0;
      return { pitch: w + gap, half: w / 2, vp: viewport.clientWidth };
    }

    function place(animate) {
      var m = metrics();
      track.style.transition = (animate && !reduce) ? '' : 'none';
      var x = m.vp / 2 - (index * m.pitch + m.half);
      track.style.transform = 'translateX(' + x + 'px)';
      if (!animate || reduce) { track.getBoundingClientRect(); track.style.transition = ''; }
    }

    function paint() {
      cards.forEach(function (c, i) { c.classList.toggle('is-active', i === index); });
      var real = ((index - N) % N + N) % N;
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === real); });
    }

    function normalize() {            // snap back into the real band, invisibly
      if (index >= 2 * N) index -= N;
      else if (index < N) index += N;
      else return;
      place(false);
    }

    function go(i, user) {
      if (busy) return;
      index = i;
      place(true); paint();
      busy = true;
      setTimeout(function () { busy = false; normalize(); paint(); }, reduce ? 0 : DUR + 20);
      if (user) restart();
    }
    function move(dir) { go(index + dir, true); }

    /* card click: focus if not active, else follow its link */
    cards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        var ci = cards.indexOf(card);
        if (ci !== index) { e.preventDefault(); go(ci, true); }
      });
    });

    if (prev) prev.addEventListener('click', function () { move(-1); });
    if (next) next.addEventListener('click', function () { move(1); });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); move(-1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); move(1); }
    });

    /* swipe */
    var sx = 0, sy = 0, sw = false;
    viewport.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; sw = true; stop(); }, { passive: true });
    viewport.addEventListener('touchend', function (e) {
      if (!sw) return; sw = false;
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) move(dx < 0 ? 1 : -1); else restart();
    }, { passive: true });

    /* autoplay — advances forward (cards travel right-to-left) */
    function play() {
      if (reduce) return;
      if (root.getAttribute('data-autoplay') !== 'true') return;
      if (timer) return;
      var secs = parseInt(root.getAttribute('data-interval'), 10) || 4;
      timer = setInterval(function () { move(1); }, secs * 1000);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function restart() { stop(); play(); }
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : play(); });

    var rt;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { place(false); }, 120); });

    /* first paint once layout settles */
    place(false); paint();
    requestAnimationFrame(function () { place(false); });
    window.addEventListener('load', function () { place(false); });
    play();
  }

  function boot() { document.querySelectorAll('[data-ca-bc]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    var bc = e.target.querySelector && e.target.querySelector('[data-ca-bc]');
    if (bc) init(bc);
  });
})();
